module.exports = __webpack_public_path__ + "img/mira.2e25ff44.svg";